// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"18":"99f669b1501fec45","154":"4bdba9c75625c62a","187":"99f669b1501fec45","888":"e0bb794acf4a9fb3"}[chunkId] + ".css";
};